<script setup lang="ts">
interface Props {
  text: string
  iconClass?: string | null
  layout?: 'horizontal' | 'vertical'
  closedByDefault?: boolean
  bg?: 'dark' | 'light'
}

withDefaults(defineProps<Props>(), {
  layout: 'vertical',
  iconClass: null,
  bg: 'light',
})
</script>

<template>
  <CardComponent
    bg="light"
    class="py-2 px-4 md:py-4"
  >
    <template v-if="$viewport.isLessThan('lg')">
      <PvAccordion :value="closedByDefault ? 'closed' : 'open'">
        <PvAccordionPanel value="open">
          <PvAccordionHeader>
            <TitleComponent
              :text
              :icon-class
              type="subtitle"
            />
          </PvAccordionHeader>
          <PvAccordionContent>
            <div class="grid gap-2 lg:gap-5 pt-4">
              <slot />
            </div>
          </PvAccordionContent>
        </PvAccordionPanel>
      </PvAccordion>
    </template>
    <template v-else>
      <div class="grid gap-2 lg:gap-3">
        <TitleComponent
          :text
          :icon-class
          no-caps
          type="subtitle"
        />
        <PvDivider />
        <slot />
      </div>
    </template>
  </CardComponent>
</template>
